import React, { CSSProperties, FunctionComponent } from 'react';

interface IProps {
  style?: CSSProperties;
  children?: React.ReactNode;
}

const FormContainer: FunctionComponent<IProps> = ({ style, children }) => <div style={style}>{children}</div>;

export default FormContainer;
